import { __require as r } from "../node_modules/@mercadopago/sdk-js/dist/index.mjs";
var i = r();
export {
  i as d
};
